export default __webpack_public_path__ + "static/media/18@3x.561aa1ea.png";